import React from 'react';

import Icon from '../../../components/AppIcon';


const QuickActions = ({ onNewConsultation, onUpdateProfile, onViewReports }) => {
  const quickActionItems = [
    {
      title: 'مشاوره جدید',
      description: 'شروع جلسه مشاوره آنلاین',
      icon: 'MessageSquare',
      color: 'bg-primary',
      action: onNewConsultation
    },
    {
      title: 'بروزرسانی پروفایل',
      description: 'ویرایش اطلاعات حرفه‌ای',
      icon: 'User',
      color: 'bg-secondary',
      action: onUpdateProfile
    },
    {
      title: 'گزارش‌ها',
      description: 'مشاهده آمار و گزارش‌ها',
      icon: 'BarChart3',
      color: 'bg-success',
      action: onViewReports
    },
    {
      title: 'تنظیمات',
      description: 'مدیریت حساب کاربری',
      icon: 'Settings',
      color: 'bg-warning',
      action: () => console.log('Settings clicked')
    }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <h3 className="text-lg font-semibold text-card-foreground mb-6">دسترسی سریع</h3>
      <div className="grid grid-cols-2 gap-4">
        {quickActionItems?.map((item, index) => (
          <button
            key={index}
            onClick={item?.action}
            className="p-4 border border-border rounded-lg hover:border-primary/50 hover:shadow-subtle transition-all duration-200 text-right group"
          >
            <div className={`w-10 h-10 ${item?.color} rounded-lg flex items-center justify-center mb-3 group-hover:scale-110 transition-transform duration-200`}>
              <Icon name={item?.icon} size={20} color="white" />
            </div>
            <h4 className="font-medium text-card-foreground mb-1">{item?.title}</h4>
            <p className="text-xs text-muted-foreground leading-relaxed">{item?.description}</p>
          </button>
        ))}
      </div>
      <div className="mt-6 pt-6 border-t border-border">
        <div className="flex items-center justify-between">
          <div>
            <h4 className="font-medium text-card-foreground">وضعیت آنلاین</h4>
            <p className="text-sm text-muted-foreground">در دسترس برای مشاوره</p>
          </div>
          <div className="flex items-center space-x-reverse space-x-2">
            <div className="w-3 h-3 bg-success rounded-full animate-pulse"></div>
            <span className="text-sm text-success font-medium">آنلاین</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuickActions;